/**
 * Which mark the bubble draws. Three, because there are only three things a
 * bubble can be saying.
 *
 * There used to be seven — Small, VerySmall, ComingSoon and
 * NormalErrorExclamation as well. They differed only in size and tint while
 * saying exactly what `Normal` says ("hover for an explanation"), so they now
 * draw the one help medallion the rest of the platform uses.
 */
export const QuestionBubbleContext = {
  /** Hover for an explanation. The everyday case. */
  Normal: 0,
  /** Trails a validation error already on screen and explains it. */
  MicroError: 1,
  /** Trails a warning already on screen and explains it. */
  MicroWarning: 2,
} as const;
export type QuestionBubbleContext =
  (typeof QuestionBubbleContext)[keyof typeof QuestionBubbleContext];
